import { render } from "./getPresentation.vue?vue&type=template&id=9b2f4b02&scoped=true"
import script from "./getPresentation.vue?vue&type=script&lang=js"
export * from "./getPresentation.vue?vue&type=script&lang=js"

import "./getPresentation.vue?vue&type=style&index=0&id=9b2f4b02&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b2f4b02"]])

export default __exports__